import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "nameField", "tagTypeField", "errorMessage"]

  connect() {
    // Only set up form handling if form targets are available
    if (this.hasFormTarget) {
      this.form = this.formTarget
      this.nameField = this.nameFieldTarget
      this.tagTypeField = this.tagTypeFieldTarget
      this.errorMessage = this.errorMessageTarget
      
      this.form.addEventListener('submit', this.handleSubmit.bind(this))
    }
    
    // Add event listeners for delete buttons
    this.addDeleteButtonListeners()
  }

  handleSubmit(event) {
    event.preventDefault()
    
    const formData = new FormData(this.form)
    
    const csrfToken = document.querySelector('meta[name="csrf-token"]')
    const headers = {
      'Accept': 'application/json'
    }
    
    if (csrfToken) {
      headers['X-CSRF-Token'] = csrfToken.content
    }
    
    fetch(this.form.action, {
      method: 'POST',
      body: formData,
      headers: headers
    })
    .then(response => {
      return response.json().then(data => {
        return { status: response.status, data: data }
      })
    })
    .then(response => {
      if (response.status === 200 && response.data.success) {
        this.handleSuccess(response.data.tag)
      } else {
        this.handleError(response.data.errors)
      }
    })
    .catch(error => {
      console.error('Error:', error)
      this.handleError(['An unexpected error occurred. Please try again.'])
    })
  }

  handleSuccess(tag) {
    // Clear the form
    this.nameField.value = ''
    this.tagTypeField.value = ''
    this.hideError()
    
    // Add the new tag to the appropriate list
    this.addTagToList(tag)
  }

  handleError(errors) {
    this.showError(errors.join(', '))
  }

  showError(message) {
    this.errorMessage.textContent = message
    this.errorMessage.style.display = 'block'
  }

  hideError() {
    this.errorMessage.style.display = 'none'
    this.errorMessage.textContent = ''
  }

  addTagToList(tag) {
    const tagElement = document.createElement('li')
    tagElement.className = 'sidebar-tag-item'
    tagElement.setAttribute('data-tag-id', tag.id)
    tagElement.innerHTML = `
      <div class="sidebar-tag-container">
        <span class="sidebar-tag-name">${tag.name} (0)</span>
        <button class="sidebar-tag-delete" data-tag-id="${tag.id}" data-tag-name="${tag.name}" data-tag-type="${tag.tag_type}">
          <i class="fas fa-times"></i>
        </button>
      </div>
    `
    
    // Find the appropriate list based on tag type
    const listSelector = tag.tag_type === 'Artist' ? '.sidebar-tags-section h6:first-of-type + ul' : '.sidebar-tags-section h6:nth-of-type(2) + ul'
    const list = document.querySelector(listSelector)
    
    if (list) {
      // Insert the tag in alphabetical order
      const existingTags = Array.from(list.children)
      const insertIndex = existingTags.findIndex(item => {
        const tagName = item.querySelector('.sidebar-tag-name').textContent
        return tagName.localeCompare(tag.name) > 0
      })
      
      if (insertIndex === -1) {
        list.appendChild(tagElement)
      } else {
        list.insertBefore(tagElement, existingTags[insertIndex])
      }
    }
  }
  
  addDeleteButtonListeners() {
    this.element.addEventListener('click', (event) => {
      if (event.target.closest('.sidebar-tag-delete')) {
        event.preventDefault()
        event.stopPropagation()
        const button = event.target.closest('.sidebar-tag-delete')
        const tagId = button.dataset.tagId
        const tagName = button.dataset.tagName
        const tagType = button.dataset.tagType
        
        this.handleDeleteClick(tagId, tagName, tagType)
      }
    })
  }
  
  handleDeleteClick(tagId, tagName, tagType) {
    if (confirm(`Are you sure you want to delete the tag "${tagName}"?`)) {
      this.deleteTag(tagId, tagName, tagType)
    } else {
      // User clicked Cancel, do nothing
      return false
    }
  }
  
  deleteTag(tagId, tagName, tagType) {
    const url = `/dashboard/tags/${tagId}`
    
    const csrfToken = document.querySelector('meta[name="csrf-token"]')
    const headers = {
      'Accept': 'application/json'
    }
    
    if (csrfToken) {
      headers['X-CSRF-Token'] = csrfToken.content
    }
    
    fetch(url, {
      method: 'DELETE',
      headers: headers
    })
    .then(response => {
      return response.json().then(data => {
        return { status: response.status, data: data }
      })
    })
    .then(response => {
      if (response.status === 200 && response.data.success) {
        // Remove the tag element from the DOM instead of reloading
        this.removeTagFromList(tagId)
      } else {
        alert('Failed to delete tag. Please try again.')
      }
    })
    .catch(error => {
      console.error('Delete error:', error)
      alert('An error occurred while deleting the tag. Please try again.')
    })
  }
  
  removeTagFromList(tagId) {
    const tagElement = document.querySelector(`[data-tag-id="${tagId}"]`)
    if (tagElement) {
      tagElement.remove()
    }
  }
} 